import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/auth";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ContactsPage from "@/pages/ContactsPage";
import DiscoveryPage from "@/pages/DiscoveryPage";
import TemplatesPage from "@/pages/TemplatesPage";
import CampaignsPage from "@/pages/CampaignsPage";
import StatsPage from "@/pages/StatsPage";
import SettingsPage from "@/pages/SettingsPage";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#f4f7f9]">
                <div className="text-slate-400 text-sm">Lädt ...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return <AppLayout>{children}</AppLayout>;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/" element={<Protected><DashboardPage /></Protected>} />
                    <Route path="/contacts" element={<Protected><ContactsPage /></Protected>} />
                    <Route path="/discovery" element={<Protected><DiscoveryPage /></Protected>} />
                    <Route path="/templates" element={<Protected><TemplatesPage /></Protected>} />
                    <Route path="/campaigns" element={<Protected><CampaignsPage /></Protected>} />
                    <Route path="/stats" element={<Protected><StatsPage /></Protected>} />
                    <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
